module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isPreview) ? _c('div', {
    staticClass: "o-media o-media--spacing-regular o-media--top c-post u-margin-bottom-regular"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('router-link', {
    attrs: {
      "to": '/post/' + _vm.slug
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.previewImage,
      "alt": _vm.title
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body u-nudge-bottom-tiny"
  }, [_c('div', {
    staticClass: "c-post__title"
  }, [_c('h2', {
    staticClass: "c-type-charlie"
  }, [_c('router-link', {
    attrs: {
      "to": '/post/' + _vm.slug
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-post__info u-margin-bottom-small"
  }, [_c('div', {
    staticClass: "o-media o-media--spacing-micro u-margin-right-small"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-user",
    attrs: {
      "use": "user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\tBy " + _vm._s(_vm.author) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "o-media o-media--spacing-micro"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-clock",
    attrs: {
      "use": "clock"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.date) + "\n\t\t\t\t\t")])])]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.preview)
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/post/' + _vm.slug
    }
  }, [_c('app-button', [_vm._v("Read more")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isPreview) ? _c('article', [_c('div', {
    staticClass: "c-post__header u-margin-bottom-reduced"
  }, [_c('div', {
    staticClass: "c-post__header-text"
  }, [_c('h2', {
    staticClass: "c-type-alpha"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "c-post__header-text-info"
  }, [_c('div', {
    staticClass: "o-media o-media--spacing-micro u-margin-right-small"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-user",
    attrs: {
      "use": "user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\t\tBy " + _vm._s(_vm.author) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "o-media o-media--spacing-micro"
  }, [_c('div', {
    staticClass: "o-media__image"
  }, [_c('icon', {
    staticClass: "c-icon-clock",
    attrs: {
      "use": "clock"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "o-media__body"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.date) + "\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('img', {
    staticClass: "u-full-width",
    attrs: {
      "src": _vm.fullImage,
      "alt": _vm.title
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40fadc11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/post/post.vue
// module id = 142
// module chunks = 1